module.exports = __webpack_public_path__ + "static/media/01A.a64b3e85.png";